import { render, staticRenderFns } from "./activetemplate.vue?vue&type=template&id=6f987032"
import script from "./activetemplate.vue?vue&type=script&lang=js"
export * from "./activetemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports